interface SettingItemType {
  key: number;
  icon: string;
  iconStyle: string;
  name: string;
  modal: string;
}

export const data: SettingItemType[] = [
  // {
  //   key: 0,
  //   icon: 'folder-tree',
  //   iconStyle: 'far',
  //   name: 'save-template',
  //   modal: 'template',
  // },
  // {
  //   key: 1,
  //   icon: 'share-square',
  //   iconStyle: 'far',
  //   name: 'send-share-link',
  //   modal: 'share',
  // },
  {
    key: 2,
    icon: 'file-alt',
    iconStyle: 'far',
    name: 'log',
    modal: 'log',
  },
  {
    key: 3,
    icon: 'file-user',
    iconStyle: 'far',
    name: 'group-rights',
    modal: 'rights',
  },
  {
    key: 4,
    icon: 'bell',
    iconStyle: 'far',
    name: 'notifications',
    modal: 'notifications',
  },
  // {
  //   key: 5,
  //   icon: 'print',
  //   iconStyle: 'far',
  //   name: 'print-project',
  //   modal: 'print',
  // },
  {
    key: 6,
    icon: 'cog',
    iconStyle: 'far',
    name: 'project-settings-mode',
    modal: 'project-settings',
  },
  {
    key: 7,
    icon: 'address-card',
    iconStyle: 'far',
    name: 'project-contacts',
    modal: 'resource',
  },
  {
    key: 8,
    icon: 'user-tie',
    iconStyle: 'fad',
    name: 'super-user-mode',
    modal: 'super-user',
  },
  {
    key: 9,
    icon: 'earth-europe',
    iconStyle: 'fas',
    name: 'language',
    modal: 'language',
  },
  {
    key: 10,
    name: 'login',
    modal: 'login',
    icon: 'sign-in-alt',
    iconStyle: 'fas',
  },
  {
    key: 11,
    name: 'logout',
    modal: 'logout',
    icon: 'sign-out-alt',
    iconStyle: 'fas',
  },
];

export const dataMobile: SettingItemType[] = [
  // {
  //   key: 0,
  //   icon: 'folder-tree',
  //   iconStyle: 'far',
  //   name: 'save-template',
  //   modal: 'template',
  // },
  // {
  //   key: 1,
  //   icon: 'share-square',
  //   iconStyle: 'far',
  //   name: 'send-share-link',
  //   modal: 'share',
  // },
  {
    key: 2,
    icon: 'file-alt',
    iconStyle: 'far',
    name: 'log',
    modal: 'log',
  },
  {
    key: 3,
    icon: 'file-user',
    iconStyle: 'far',
    name: 'group-rights',
    modal: 'rights',
  },
  {
    key: 4,
    icon: 'bell',
    iconStyle: 'far',
    name: 'notifications',
    modal: 'notifications',
  },
  // {
  //   key: 5,
  //   icon: 'print',
  //   iconStyle: 'far',
  //   name: 'print-project',
  //   modal: 'print',
  // },
  {
    key: 6,
    icon: 'user-tie',
    iconStyle: 'fad',
    name: 'super-user-mode',
    modal: 'super-user',
  },
  {
    key: 7,
    icon: 'mobile',
    iconStyle: 'fad',
    name: 'mobile-view',
    modal: 'mobile-view',
  },
];

export const dataTimeMachine: SettingItemType[] = [
  {
    key: 2,
    icon: 'file-alt',
    iconStyle: 'far',
    name: 'log',
    modal: 'log',
  },
  {
    key: 3,
    icon: 'file-user',
    iconStyle: 'far',
    name: 'group-rights',
    modal: 'rights',
  },
  {
    key: 6,
    icon: 'user-tie',
    iconStyle: 'fad',
    name: 'super-user-mode',
    modal: 'super-user',
  },
];

// export default { data, dataSuperUser };
